module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/5-1d170bbc4ba0ae19f5554ed083a70956.jpeg";